import { useComposedRefs } from "../utils/use-composed-refs.js";
import { useMediaAttach } from "../player/context.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/media/audio.tsx
const Audio = forwardRef(function Audio({ children, ...props }, ref) {
	const setMedia = useMediaAttach();
	const composedRef = useComposedRefs(ref, setMedia);
	return /* @__PURE__ */ jsx("audio", {
		ref: composedRef,
		...props,
		children
	});
});
//#endregion
export { Audio };

//# sourceMappingURL=audio.js.map